import { render, staticRenderFns } from "./LotesDetail.vue?vue&type=template&id=710335fb&scoped=true"
import script from "./LotesDetail.vue?vue&type=script&lang=js"
export * from "./LotesDetail.vue?vue&type=script&lang=js"
import style0 from "./LotesDetail.vue?vue&type=style&index=0&id=710335fb&prod&lang=scss&scoped=true"
import style1 from "./LotesDetail.vue?vue&type=style&index=1&id=710335fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710335fb",
  null
  
)

export default component.exports